<template>
<v-dialog
    v-model="dialog"
    fullscreen
    v-if="event != null"
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Edit Calendar Event</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickCancel"
                >
                    Cancel
                </v-btn>

                <v-btn
                    dark
                    text
                    @click="onClickSave"
                >
                    Save &amp; Close
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

            <v-row
                style="margin-top: 15px"
            >
                <v-col>
                    <m-edit-instant
                        label="Start"
                        :value="event.time_start"
                        :timezone="this.$rc.$state.getPrimaryTimezone()"
                        v-on:input="onChangeStartTime"
                    />
                </v-col>

                <v-col>
                    <m-edit-instant
                        label="Stop"
                        v-model="event.time_end"
                        :timezone="this.$rc.$state.getPrimaryTimezone()"
                    />
                </v-col>

            </v-row>

            <v-text-field
                label="Title"
                v-model="event.title"
                style="margin-top: 15px"
                autocomplete="off"
            />

            <v-textarea
                label="Body"
                v-model="event.body"
                rows="1"
                auto-grow
                autocomplete="off"
            />

            <v-text-field
                label="Join URL"
                v-model="event.join_url"
                hint="Typically, the Zoom link used to join the meeting"
                autocomplete="off"
            />

            <v-row>
                <v-col>
                    <m-autocomplete
                        label="Owner (RedChirp Employee)"
                        v-model="event.owned_by_employee_id"
                        type="system-admins"
                    />
                </v-col>
                <v-col>
                     <m-autocomplete
                        label="For Organization"
                        v-model="event.for_organization_id"
                        type="organization"
                    />
                </v-col>
                <v-col>
                    <v-select
                        label="Purpose"
                        v-model="event.purpose"
                        :items="$rc.enumChoices('event_purpose',true)"
                    />
                </v-col>
            </v-row>

            <b>Invitees</b>

            <v-row
                v-for="(item, index) in event.invitees"
                :key="'invitee_'+index"
            >
                <v-col>
                   <v-text-field
                        label='Name'
                        v-model='item.name'
                   />
                </v-col>

                <v-col>
                   <v-text-field
                        label='Email'
                        v-model='item.email'
                   />
                </v-col>
            </v-row>

            <m-icon-bar
                v-on:add="onAddInvitee"
            />


            <div
                style="text-align: right; margin-top: 15px;"
            >
                <v-btn
                    v-on:click="onClickSave"
                    color="primary"
                >
                    Save &amp; Close
                </v-btn>
            </div>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>
import mIconBar from '../../../components/input/m-icon-bar.vue';
const _ = require('lodash');
export default {
  components: { mIconBar },

    data() {
        return {
            dialog: false,
            last_dialog_guard: null,
            event: null,
        }
    },

    methods: {

        showDialog(event)
        {
            this.event = _.cloneDeep(event);
            this.dialog = true;
            this.last_dialog_guard = this.$router.dialog_guard;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = this.last_dialog_guard;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.closeDialog();
                return;
            }
        
            this.closeDialog();
            next(false);
        },

        onClickSave()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/calendar/event',
            
                'params' : this.event,
            
                'on_success': (data) => {
                        this.closeDialog();
                        this.$emit('update',this.event);
                    },
            
                'on_error': 'Unable to save calendar event',
            });
        },

        onClickCancel()
        {
            this.closeDialog();
        },

        onChangeStartTime(new_time)
        {
            let duration = this.event.time_end - this.event.time_start;

            this.event.time_start = new_time;
            this.event.time_end = new_time + duration;
        },

        onAddInvitee()
        {
            this.event.invitees.push({
                'invitee_id': this.$rc.uuidv4(),
                'name': '',
                'email': '',
            });
        },

    },
}
</script>

<style lang="scss" scoped>
</style>